export default __webpack_public_path__ + "static/4-805ad6739fb54d3f140643580e4d10cf.jpg";